import { useEffect, useState } from "react";
import { Drawer, Form, Input, Button, Row, Col, Select, DatePicker, InputNumber, Divider, Tooltip } from "antd";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import { createProducto } from "../../../../services/financiero/finProductosService";
import { getProveedores } from "../../../../services/financiero/finProveedoresService";
import { getEstados } from "../../../../services/financiero/finEstadoService";
import { getUnidadesMedida } from "../../../../services/financiero/finUnidadMedidaService";

export default function ProductosBulkForm({ open, onClose, onSuccess, userLogin }) {

  const [form] = Form.useForm();
  const [proveedores, setProveedores] = useState([]);
  const [estados, setEstados] = useState([]);
  const [unidades, setUnidades] = useState([]);

  const estadoMap = {
    "FINALLY CLOSED": "Entregado",
    "CLOSED": "Cerrado",
    "CLOSED FOR RECEIVING": "Cerrado para recepción",
    "OPEN": "Pendiente",
    "PENDING": "Pendiente"
  };

  useEffect(() => {
    cargarCatalogos();
  }, []);

  const cargarCatalogos = async () => {
    const prov = await getProveedores();
    const est = await getEstados();
    const uni = await getUnidadesMedida();
    setProveedores(prov);
    setEstados(est);
    setUnidades(uni);
  }

  const handleSubmit = async (values) => {
    try {
      const productos = values.productos || [];
      for (const p of productos) {

        const data = {
          ...p,
          cantidad: Number(p.cantidad) || 0,
          valor_unitario_COP: Number(p.valor_unitario_COP) || 0,
          valor_unitario_USD: Number(p.valor_unitario_USD) || 0,
          fecha_estimada_entrega:
            p.fecha_estimada_entrega
              ? p.fecha_estimada_entrega.format("YYYY-MM-DD")
              : null
        };

        await createProducto(data, userLogin);

      }
      form.resetFields();
      onSuccess?.();
      onClose();
    }
    catch (error) {
      console.error(error);
    }
  }

  return (
    <Drawer
      title="Registro múltiple de productos"
      open={open}
      onClose={onClose}
      width={1700}
      extra={
        <Button
          type="primary"
          onClick={() => form.submit()}
        >
          Guardar productos
        </Button>
      }
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
      >
        <Divider orientation="left">
          Productos a registrar
        </Divider>
        <Row
          gutter={10}
          style={{
            fontWeight: 600,
            marginBottom: 8,
            color: "#6b7280"
          }}
        >
          <Col span={2}>PO</Col>
          <Col span={3}>Producto</Col>
          <Col span={2}>Tipo</Col>
          <Col span={2}>Unidad</Col>
          <Col span={3}>Proveedor</Col>
          <Col span={1}>Cant</Col>
          <Col span={2}>COP</Col>
          <Col span={2}>USD</Col>
          <Col span={3}>Estado</Col>
          <Col span={2}>Entrega</Col>
          <Col span={2}>Localización</Col>
          <Col span={1}></Col>
        </Row>
        <Form.List name="productos">
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restField }) => (
                <Row
                  gutter={10}
                  key={key}
                  style={{
                    marginBottom: 8,
                    padding: 8,
                    borderRadius: 6,
                    background: "#fafafa"
                  }}
                >
                  <Col span={2}>
                    <Form.Item
                      {...restField}
                      name={[name, "Numero_PO"]}
                      rules={[{ required: true }]}
                    >
                      <Input placeholder="PO" />
                    </Form.Item>
                  </Col>
                  <Col span={3}>
                    <Form.Item
                      {...restField}
                      name={[name, "nombre_producto"]}
                      rules={[{ required: true }]}
                    >
                      <Input placeholder="Producto" />
                    </Form.Item>
                  </Col>
                  <Col span={2}>
                    <Form.Item
                      {...restField}
                      name={[name, "tipo_producto"]}
                    >
                      <Input placeholder="Tipo" />
                    </Form.Item>
                  </Col>
                  <Col span={2}>
                    <Form.Item
                      {...restField}
                      name={[name, "oid_unidad_medida"]}
                    >
                      <Select
                        showSearch
                        placeholder="Unidad"
                      >
                        {unidades.map(u => (
                          <Select.Option
                            key={u.oid}
                            value={u.oid}
                          >
                            {u.unidad_medida}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={3}>
                    <Form.Item
                      {...restField}
                      name={[name, "oid_proveedor"]}
                    >
                      <Select
                        showSearch
                        placeholder="Proveedor"
                      >
                        {proveedores.map(p => (
                          <Select.Option
                            key={p.oid}
                            value={p.oid}
                          >
                            {p.nombre}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={1}> <Form.Item {...restField} name={[name, "cantidad"]} > <InputNumber style={{ width: "100%" }} min={0} /> </Form.Item> </Col>
                  <Col span={2}>
                    <Form.Item
                      {...restField}
                      name={[name, "valor_unitario_COP"]}
                    >
                      <InputNumber
                        style={{ width: "100%" }}
                        min={0}
                        formatter={v =>
                          `$ ${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col span={2}>
                    <Form.Item
                      {...restField}
                      name={[name, "valor_unitario_USD"]}
                    >
                      <InputNumber
                        style={{ width: "100%" }}
                        min={0}
                        formatter={v => `$ ${v}`}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={3}>
                    <Form.Item
                      {...restField}
                      name={[name, "oid_estado"]}
                    >
                      <Select placeholder="Estado">
                        {estados.map(e => {
                          const estadoVisual =
                            estadoMap[e.estado] || e.estado;
                          return (
                            <Select.Option
                              key={e.oid}
                              value={e.oid}
                            >
                              {estadoVisual}
                            </Select.Option>
                          )
                        })}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={2}>
                    <Form.Item
                      {...restField}
                      name={[name, "fecha_estimada_entrega"]}
                    >
                      <DatePicker
                        style={{ width: "100%" }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={2}>
                    <Form.Item
                      {...restField}
                      name={[name, "localizacion"]}
                    >
                      <Input placeholder="Ciudad" />
                    </Form.Item>
                  </Col>
                  <Col span={1}>
                    <Tooltip title="Eliminar fila">
                      <Button
                        danger
                        icon={<DeleteOutlined />}
                        onClick={() => remove(name)}
                      />

                    </Tooltip>
                  </Col>
                </Row>
              ))}
              <Button
                type="dashed"
                icon={<PlusOutlined />}
                onClick={() => add()}
                block
                style={{
                  marginTop: 10,
                  height: 40,
                  borderRadius: 6
                }}
              >
                Agregar producto
              </Button>
            </>
          )}
        </Form.List>
      </Form>
    </Drawer>
  )
}